import React from 'react';
import styled, { css } from 'styled-components';

import TrashIcon from '@/assets/svg/trash.svg';
import TrashV2Icon from '@/assets/svg/trash-v2.svg';
import CrossIcon from '@/assets/svg/cross.svg';
import { Props } from '@/components/FilterTags/FilterTags.types';
import { colors } from '@/constants/theme';

function FilterTags({
  selectedFilters,
  layout,
  handleDelete,
  handleDeleteAll,
  useForStock,
}: Props) {
  const isMobile = layout === 'mobile';

  return (
    <Component active={selectedFilters.length > 0}>
      {isMobile && (
        <DeleteAll isMobile={isMobile} onClick={() => handleDeleteAll?.()}>
          <DeleteAllSvg>
            {!useForStock ? <TrashIcon /> : <TrashV2Icon />}
          </DeleteAllSvg>
        </DeleteAll>
      )}
      <FilterTagsList isMobile={isMobile}>
        {selectedFilters.map((item, index) => {
          return (
            <FilterTagsItem
              key={item.value + index}
              isMobile={isMobile}
              useForStock={useForStock}
            >
              {item.label}{' '}
              <DeleteItem
                onClick={() => handleDelete?.(item)}
                useForStock={useForStock}
              >
                <CrossIcon />
              </DeleteItem>
            </FilterTagsItem>
          );
        })}
        {isMobile || (
          <DeleteAll onClick={() => handleDeleteAll?.()}>
            {useForStock && <DeleteAllText>Очистить всё</DeleteAllText>}
            <DeleteAllSvg>
              {!useForStock ? <TrashIcon /> : <TrashV2Icon />}
            </DeleteAllSvg>
          </DeleteAll>
        )}
      </FilterTagsList>
    </Component>
  );
}

export default FilterTags;

const Component = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${({ active }) =>
    active
      ? null
      : css`
          display: none;
        `}
`;

const FilterTagsList = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-wrap: wrap;

  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-wrap: nowrap;
      width: 100%;
      overflow-x: auto;
      margin-left: 10px;
    `}
`;

const FilterTagsItem = styled.div<{ isMobile: boolean; useForStock?: boolean }>`
  display: flex;
  background-color: ${colors.main};
  align-items: center;
  justify-content: center;
  height: 35px;
  margin-right: 15px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: ${colors.white};
  padding: 8px 13px 8px 20px;
  border-radius: 6px;
  white-space: nowrap;

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-bottom: 0;
    `}

  ${({ useForStock }) =>
    useForStock &&
    css`
      background: #ebecf0;
      color: ${colors.blue600};
    `}
`;

const DeleteAll = styled.button<{ isMobile?: boolean; useForStock?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  &:hover {
    & > div {
      color: ${colors.main100};
    }

    & > div > svg {
      fill: ${colors.main100};
    }
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-bottom: 0;
    `}
`;

const DeleteAllSvg = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    fill: ${colors.main};
    transition: 0.2s;

    path {
      fill: ${colors.main};
    }
  }
`;

const DeleteAllText = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-right: 10px;
  color: ${colors.main};
`;

const DeleteItem = styled.div<{ useForStock?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;

  svg {
    transition: 0.2s;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }

  ${({ useForStock }) =>
    useForStock &&
    css`
      svg {
        fill: ${colors.main};
        transition: 0.2s;

        &:hover {
          opacity: 0.5;
        }
      }
    `}
`;
